import { Box } from '@chakra-ui/react';
import TypingIndicator from '@duke-hq/ui/components/TypingIndicator/TypingIndicator';

// -- ConversationTypingIndicator -----------------------------------------------
// The typing dots shown while the next message is revealed, shared by the student
// runtime and the admin previews. Indented past the avatar column so the dots
// align with the bubbles' left edge. Render it in the same layout context as the
// messages so it shares their left origin. Holds its space (visibility, not
// unmount) so the layout doesn't jump.
const AVATAR_COLUMN = '2rem';

export function ConversationTypingIndicator({
  visible,
  speed,
}: {
  visible: boolean;
  /** Playback speed; scales the dot animation. Omit for default speed. */
  speed?: number;
}) {
  return (
    <Box
      mt="2"
      pl={`calc(${AVATAR_COLUMN} + var(--chakra-space-2))`}
      visibility={visible ? 'visible' : 'hidden'}
    >
      <TypingIndicator color="var(--chakra-colors-fg-muted)" width={6} height={6} speed={speed} />
    </Box>
  );
}
